import React, { useState, useEffect } from 'react';
import axiosClient, { UPLOADS_BASE_URL } from '../../axios_client';

const UpdateAdminGallery = ({ isOpen, onClose, galleryItemData, onGalleryItemUpdated }) => {
    const [section, setSection] = useState('');
    const [image, setImage] = useState(null);
    const [error, setError] = useState('');

    // Define base URL for images (adjust for production)
    const BASE_URL = UPLOADS_BASE_URL; // Use https://sunflower-resort.com for production

    useEffect(() => {
        if (galleryItemData) {
            setSection(galleryItemData.section);
            setImage(null); // Reset image input
        }
    }, [galleryItemData]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const formData = new FormData();
        if (section) formData.append('section', section);
        if (image) formData.append('image', image);

        try {
            await axiosClient.put(`/gallery/${galleryItemData.id}`, formData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            onGalleryItemUpdated();
            onClose();
            setSection('');
            setImage(null);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to update gallery item');
        }
    };

    // Normalize image URL to ensure it starts with a slash
    const getImageUrl = (img) => {
        if (!img) return '/fallback-image.jpg';
        const path = img.startsWith('/') ? img : `/${img}`;
        return `${BASE_URL}${path}`;
    };

    if (!isOpen || !galleryItemData) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4 sm:px-6">
            <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-xs sm:max-w-md">
                <h2 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-[#12392B]">
                    Update Gallery Item
                </h2>
                {error && (
                    <p className="text-red-500 text-sm sm:text-base mb-3 sm:mb-4">
                        {error}
                    </p>
                )}
                <form onSubmit={handleSubmit}>
                    <div className="mb-3 sm:mb-4">
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="section"
                        >
                            Section
                        </label>
                        <select
                            id="section"
                            value={section}
                            onChange={(e) => setSection(e.target.value)}
                            className="w-full p-2 sm:p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#E6A71A] text-sm sm:text-base"
                            required
                            aria-label="Section"
                        >
                            <option value="">Select Section</option>
                            <option value="Resort">Resort</option>
                            <option value="Ayurveda">Ayurveda</option>
                            <option value="Restaurant">Restaurant</option>
                            <option value="Beach">Beach</option>
                        </select>
                    </div>
                    <div className="mb-3 sm:mb-4">
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="currentImage"
                        >
                            Current Image
                        </label>
                        {galleryItemData.image ? (
                            <img
                                src={getImageUrl(galleryItemData.image)}
                                alt={galleryItemData.section}
                                className="w-auto h-16 sm:h-20 object-cover rounded mb-2"
                                onError={(e) => {
                                    console.error(`Failed to load image: ${getImageUrl(galleryItemData.image)}`);
                                    e.target.src = '/fallback-image.jpg';
                                }}
                            />
                        ) : (
                            <p className="text-gray-500 text-sm sm:text-base">No image available</p>
                        )}
                    </div>
                    <div className="mb-3 sm:mb-4">
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="image"
                        >
                            New Image (optional)
                        </label>
                        <input
                            type="file"
                            id="image"
                            accept="image/jpeg,image/png"
                            onChange={(e) => setImage(e.target.files[0])}
                            className="w-full p-2 sm:p-3 border border-gray-300 rounded text-sm sm:text-base"
                            aria-label="Upload New Image"
                        />
                    </div>
                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-gray-500 text-white p-2 sm:p-3 rounded hover:bg-gray-600 transition text-sm sm:text-base"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="bg-[#12392B] text-white p-2 sm:p-3 rounded hover:bg-[#E6A71A] hover:text-[#12392B] transition text-sm sm:text-base"
                        >
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateAdminGallery;